import React, {useEffect, useState} from 'react';
import {getCalApi} from "@calcom/embed-react";
import { motion } from 'framer-motion';
import axios from "axios";
import {AnimatePresence} from "framer-motion";
import WebinaireCard from "../WebinaireCard";

function Webinaires() {
    const [webinairesData, setWebinaires] = useState([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_WEBINAIRES_ALL}/lahalle`);
                setWebinaires(Object.values(response.data));
            } catch (error) {
                console.error('Erreur lors de la récupération des données :', error);
            }
        };

        fetchData();
    }, []);
    console.log(webinairesData);
    useEffect(()=>{
        (async function () {
            const cal = await getCalApi({"namespace":"ligne-inclusion"});
            cal("ui", {"styles":{"branding":{"brandColor":"#000000"}},"hideEventTypeDetails":false,"layout":"month_view"});
        })();
    }, [])

    return (
            <section className="layout-pt-50 layout-pb-50 page-lahalle webinaires-lahalle">
                <div className="auto-container">
                    <div className="text-center">
                        <h2 className="libre-title raleway">Webinaires : des rdvs pour <span>comprendre, agir et inclure</span></h2>

                        <div className="mt-3 nunito">
                            La Halle vous donne rendez-vous pour une série de <b>webinaires exclusifs dédiés au handicap au travail. </b>
                            Ces rencontres, <b>ouvertes à tous les collaborateurs</b>, permettent en une heure d’apprendre,
                            de poser ses questions et de contribuer activement à une culture d’entreprise inclusive.
                        </div>
                        {Array.isArray(webinairesData) && webinairesData.length > 0 && (
                            <div className="row wow fadeInUp mt-2">
                                <div className="content-column col-12 d-flex justify-content-center">
                                    <div className="col-10 mb-4 mt-3">
                                        <ul className="row banner-section-dedicated-list small justify-content-center halle-bleu">
                                            <li className="col-lg-3 col-md-3 col-sm-12 default-black">
                                                <b><i className="fas fa-laptop"></i> 100% en ligne</b>
                                            </li>
                                            <li className="col-lg-3 col-md-3 col-sm-12 default-black">
                                                <b><i className="far fa-clock"></i> 1h seulement</b>

                                            </li>
                                            <li className="col-lg-3 col-md-3 col-sm-12 default-black">
                                                <b><i className="fas fa-users"></i> Ouvert à toutes et tous</b>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <AnimatePresence>
                                    {webinairesData.slice(0, 4).map((webinaire, i) => (
                                        <WebinaireCard
                                            key={webinaire.id ? `webinaire-${webinaire.id}` : `webinaire-${i}`}
                                            webinaire={webinaire}
                                        />
                                    ))}
                                </AnimatePresence>
                            </div>
                        )}
                        <a
                            href="https://www.talents-handicap.com/lahalle/webinaires"
                            className="theme-btn btn-style-one"
                            target={"_blank"}
                        >
                            Découvrir les webinaires
                        </a>
                    </div>

                </div>
            </section>
    );
}

export default Webinaires;
